import { render, staticRenderFns } from "./Samples.vue?vue&type=template&id=39b36662&scoped=true"
import script from "./Samples.vue?vue&type=script&lang=js"
export * from "./Samples.vue?vue&type=script&lang=js"
import style0 from "./Samples.vue?vue&type=style&index=0&id=39b36662&prod&lang=css"
import style1 from "./Samples.vue?vue&type=style&index=1&id=39b36662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b36662",
  null
  
)

export default component.exports